import React, { useMemo, useState } from 'react';
import { KENYA_COUNTIES, getSubCounties, getTowns } from '../../data/kenyaLocations';

const OTHER = '__other__';

const KenyaLocationFields = ({
  county = '',
  subCounty = '',
  town = '',
  onChange,
  className = 'grid grid-cols-1 md:grid-cols-3 gap-4'
}) => {
  const [customTown, setCustomTown] = useState(false);

  const counties = useMemo(() => {
    if (county && !KENYA_COUNTIES.includes(county)) return [county, ...KENYA_COUNTIES];
    return KENYA_COUNTIES;
  }, [county]);

  const subCounties = useMemo(() => {
    const list = getSubCounties(county);
    if (subCounty && !list.includes(subCounty)) return [subCounty, ...list];
    return list;
  }, [county, subCounty]);

  const towns = useMemo(() => {
    const list = getTowns(county, subCounty);
    if (town && !list.includes(town) && !customTown) return [town, ...list];
    return list;
  }, [county, subCounty, town, customTown]);

  const townValue = customTown ? OTHER : town;

  const emit = (patch) => onChange({ county, subCounty, town, ...patch });

  return (
    <div className={className}>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">County</label>
        <select
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={county}
          onChange={(e) => {
            setCustomTown(false);
            emit({ county: e.target.value, subCounty: '', town: '' });
          }}
        >
          <option value="">Select county</option>
          {counties.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Sub-county</label>
        <select
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-50"
          value={subCounty}
          disabled={!county}
          onChange={(e) => {
            setCustomTown(false);
            emit({ subCounty: e.target.value, town: '' });
          }}
        >
          <option value="">{county ? 'Select sub-county' : 'Pick a county first'}</option>
          {subCounties.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Town</label>
        <select
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-50"
          value={townValue}
          disabled={!subCounty}
          onChange={(e) => {
            if (e.target.value === OTHER) {
              setCustomTown(true);
              emit({ town: '' });
            } else {
              setCustomTown(false);
              emit({ town: e.target.value });
            }
          }}
        >
          <option value="">{subCounty ? 'Select town' : 'Pick a sub-county first'}</option>
          {towns.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
          <option value={OTHER}>Other…</option>
        </select>
        {customTown && (
          <input
            type="text"
            className="w-full mt-2 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Type the town name"
            value={town}
            onChange={(e) => emit({ town: e.target.value })}
            autoFocus
          />
        )}
      </div>
    </div>
  );
};

export default KenyaLocationFields;
